import { useEffect } from 'react'
import { trackExperimentViewed } from '@mc/track-event'
import { PROMO_BANNER_ALL_CLASSES_FLAG_NAME } from '../constants'

export const useTrackExperimentViewed = () => {
  useEffect(() => {
    trackExperimentViewed(PROMO_BANNER_ALL_CLASSES_FLAG_NAME)
  }, [])
}
